<template>
  <div
    class="
      sc-element page
    ">
    <div class="header">
      <div>
        <h4 class="title">
          {{ title }}
        </h4>
        <h6 v-if="subTitle" class="sub-title">
          {{ subTitle }}
        </h6>
      </div>
    </div>
    <router-view
      @sub-title="
        setSubTitle
      "
    />
  </div>
</template>

<script>
export default {
  data () {
    return {
      title     : 'Subscribers Report',
      subTitle  : null
    }
  },
  computed: {
    breadcrumb() {
      return []
    }
  },
  methods: {
    setSubTitle(data) {
      this.subTitle = data
    },
  }
}
</script>

<style
  lang="css" scoped src="../../../assets/styles/sc-element.css">
</style>

<style lang="css" scoped>

.header {
  border-bottom: 1px solid #efefef;
}

.header .title {
  margin: 0;
}

.header .sub-title {
  color       : #606266;
  margin      : 0;
  margin-top  : .25rem;
}

</style>
